<template>
  <div class="global-container">
    <div class="abt">
      <div class="abt__intro">
        <div>
          <h1 class="mb-sm">Wir sind die helping heads</h1>
          <p>
            Unsere Kraft liegt in einzigartigen Konzepten und Ideen, welche von
            unserem gesamten Team geschaffen werden. Wir arbeiten harmonisch
            zusammen, und schaffen so ein angenehmes Arbeitsklima in unserem
            Team. Wir achten speziell auf ein gutes, freundliches und
            professionelles Auftreten unserer Mitarbeiter, welches von vielen
            unserer Kund*innen sehr geschätzt wird.
          </p>
        </div>
        <div class="logo-svg">
          <img
            class="logo_svg mt-xxs"
            :src="require('@/assets/logo_col_2.svg')"
            alt="Logo"
          />
        </div>
      </div>
      <div class="abt__name">
        <H2Text
          headline="Unser Name"
          text="Unseren Firmennamen haben wir gewählt, da wir allen verschiedenen
          Branchen, für die wir arbeiten ein Gefühl von Hilfe bei Ideen,
          Entwicklungen und Umsetzung bieten wollen. Weiters geht es uns um
          einen starken Zusammenhalt zwischen Kund*innen und uns, welches auch
          unser Logo repräsentiert. Wir freuen uns auf eine gute, produktive und
          kreative Zusammenarbeit."
        />
      </div>
      <div class="abt__emp">
        <H2Text
          headline="Unsere Mitarbeiter"
          text="Unser Team setzt sich aus dem Head of helping heads und Projektleiter,
          einer Team- und Projektleiterin, zwei technischen Kräften und einem
          Grafiker zusammen. Wir würden uns als bodenständigen, familiären und
          kreativen Verein bezeichnen, der mit Spaß und Leichtigkeit all die
          Wünsche unserer Kund*innen erfüllt."
        />
      </div>
      <div class="emp__cards mt-lg">
        <employeeCard
          :employee="{
            name: 'Kurt Berger',
            tag: 'Head of helping heads',
            phone: '+43 664 3322677',
            mail: 'kurt@helpingheads.at',
          }"
        />
        <employeeCard
          :employee="{
            name: 'Sina Bickel',
            tag: 'Projekt- & Teamleitung',
            phone: '+43 664 88513388',
            mail: 'sina@helpingheads.at',
          }"
        />
        <employeeCard
          :employee="{
            name: 'Florian Prassé',
            tag: 'Web- & Grafik',
            phone: '+43 664 1401729',
            mail: 'hallo@florianprassee.at',
          }"
        />
        <employeeCard
          :employee="{
            name: 'René Jedlicka',
            tag: 'Technische Leitung',
            phone: '+43 660 5455164',
            mail: 'rene@helpingheads.at',
          }"
        />
        <employeeCard
          :employee="{
            name: 'Gabriel Greber',
            tag: 'Technische Leitung',
            phone: '+43 660 5455164',
            mail: 'gabriel@helpingheads.at',
          }"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import H2Text from "@/components/h2Text.vue";
import employeeCard from "@/components/employeeCard.vue";
</script>

<style scoped lang="scss">
.abt__intro {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: map-get($spaces, "sm");
  @media (max-width: 500px) {
    margin-top: 25vh;
  }
  img {
    position: absolute;
    top: 3%;
    right: -30%;
    width: 100%;
    height: auto;
    @media (max-width: 1200px) {
      top: 5%;
    }
    @media (max-width: 768px) {
      display: none;
    }
  }
}
.abt__name,
.abt__emp {
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30vh 0;
}
</style>
